import Cookies from 'js-cookie'

// CAPI PageView matching is emitted only from the marketing/buy domains.
const CAPI_ALLOWED_HOSTS = ['www-staging.maximustribe.com', 'www.maximustribe.com']

export const isCapiPageViewHost = () =>
  typeof window !== 'undefined' && CAPI_ALLOWED_HOSTS.includes(window.location.hostname)

// Meta's fbc format when `_fbc` is absent but the URL carries `fbclid`.
// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
export const fbcFromFbclid = (fbclid, creationTimeMs = Date.now()) =>
  fbclid ? `fb.1.${creationTimeMs}.${fbclid}` : undefined

export const FBC_COOKIE = 'mx_fbc'
const FBC_COOKIE_EXPIRY_DAYS = 90

// Cap guards against crafted/garbage fbclid values (real ones are ~100 chars).
const MAX_FBCLID_LENGTH = 512

const persistFbc = fbc => {
  try {
    Cookies.set(FBC_COOKIE, fbc, {
      expires: FBC_COOKIE_EXPIRY_DAYS,
      domain: '.maximustribe.com',
      secure: true,
      sameSite: 'Lax',
    })
  } catch {
    // Cookies blocked by tracking prevention — non-fatal.
  }
}

// No Meta Pixel on this site, so `_fbc` is usually absent: derive fbc from the
// landing `fbclid` and persist it so it survives deep navigation.
const resolveFbc = () => {
  if (typeof window === 'undefined') return undefined

  const pixelFbc = Cookies.get('_fbc')
  if (pixelFbc) return pixelFbc

  const fbclid = new URLSearchParams(window.location.search).get('fbclid')?.trim()
  if (fbclid && fbclid.length <= MAX_FBCLID_LENGTH) {
    const fbc = fbcFromFbclid(fbclid)
    persistFbc(fbc)
    return fbc
  }

  return Cookies.get(FBC_COOKIE) || undefined
}

export const getFacebookMatchParameters = () => {
  const params = {}

  const fbp = Cookies.get('_fbp')
  if (fbp) {
    params.fbp = fbp
  }

  const fbc = resolveFbc()
  if (fbc) {
    params.fbc = fbc
  }

  return params
}
